export default "__VITE_ASSET__991c30ff__"